import type { FaireProductEntity } from "../../entity_types/product";

export const p_bawcqhgzgw: FaireProductEntity = {
  token: "p_bawcqhgzgw",
  type: "product",
  name: "Cocoa Blanc | The Body Lotion",
  brandToken: "b_zsz6ut4der",
  brandName: "LNX",
  imageUrl: "https://cdn.faire.com/fastly/afb2b844fa042a4dd3e61229630ab8f2564c2fd5c2961b0ea0f53e5810eebb36.png",
  galleryImageUrls: [],
  priceDollars: 19.5,
  description: "COCOA BLANC BODY LOTION\n\nCreamy\\. Warm\\. Irresistibly smooth\\.\n\nCocoa Blanc wraps your skin in a luxurious blend of creamy cocoa butter, soft vanilla, warm coconut, and smooth sandalwood\\. Vanilla tonka adds a velvety sweetness while golden amber and soft musk create a warm, sophisticated finish that lingers beautifully on the skin\\.\n\nThe silky body lotion glides on effortlessly, leaving skin feeling soft, smooth, and moisturized without feeling heavy\\. Perfect for everyday use or layered with your Cocoa Blanc perfume oil for a richer, longer lasting scent experience\\.\n\nWarm, creamy, and beautifully refined\\. Like whipped cocoa butter, smooth vanilla, and warm woods melting into bare skin\\.\n\nScent Notes: Cocoa Butter · Creamy Vanilla · Warm Coconut · Vanilla Tonka · Sandalwood · Golden Amber · Soft Musk\n\n4 oz / 118 mL",
  tags: [],
  msrpDollars: 39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:54.522Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
